import { ChangeDetectionStrategy, Component, InputSignal, computed, inject, input } from "@angular/core";
import { CommercialSalesDataService } from "src/services/commercial/commercial-sales-data.service";
import { MiniInfocardImageCarouselComponent } from "./components/mini-infocard-image-carousel/mini-infocard-image-carousel.component";
import { EvCore } from "ev-core";
import { MapActionsService } from "src/services/map/map-actions.service";
import { IMiniInfocardCommercial } from "src/models/commercial/IMiniInfocardDataCommercial.model";
import { EvAccordionComponent } from "ev-accordion";
import { CommercialSalePropertyInfoComponent } from "./commercial-sale-property-info/commercial-sale-property-info.component";
import { EVEstateType } from "src/models/units/unit-attributes.model";
import { ResidentialSalePropertyInfoComponent } from "./residential-sale-property-info/residential-sale-property-info.component";
import { toSignal } from "@angular/core/rxjs-interop";

@Component({
    selector: "commercial-sale-infocard",
    imports: [EvCore, MiniInfocardImageCarouselComponent, EvAccordionComponent, CommercialSalePropertyInfoComponent, ResidentialSalePropertyInfoComponent],
    templateUrl: "./commercial-sale-infocard.component.html",
    styleUrl: "./commercial-sale-infocard.component.scss",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CommercialSaleInfocardComponent {
    selectedSale: InputSignal<IMiniInfocardCommercial> = input.required();
    private readonly commercialSalesDataService = inject(CommercialSalesDataService);
    private readonly mapActionsService: MapActionsService = inject(MapActionsService);
    imagePackages = toSignal(this.commercialSalesDataService.imagePackages$);
    isCommercialSale = computed(() => {
        let selected = this.selectedSale();
        if (!selected) return false;

        return this.estateTypesToShowAsCommercial.includes(selected.estateType);
    });
    showSale(sale: IMiniInfocardCommercial): void {
        this.commercialSalesDataService.setSelectedSale(sale);
    }
    close() {
        this.commercialSalesDataService.setSelectedSale(null);
    }

    centerMap(): void {
        this.mapActionsService.centerOn({ lat: this.selectedSale().decimalLatitude, lng: this.selectedSale().decimalLongitude });
    }

    showInMap(): void {
        this.mapActionsService.makeOutline({ lat: this.selectedSale().decimalLatitude, lng: this.selectedSale().decimalLongitude });
    }

    private readonly estateTypesToShowAsCommercial: EVEstateType[] = [
        EVEstateType.Ukjent,
        EVEstateType.Skole,
        EVEstateType.Næring,
        EVEstateType.Landbruk,
        EVEstateType.Garasje,
        EVEstateType.Ubebygd,
        EVEstateType.Offentlig,
        EVEstateType.Helse,
        EVEstateType.MediaKomm,
        EVEstateType.KulturIdrett,
        EVEstateType.Religion,
        EVEstateType.Transport,
        EVEstateType.Annet,
    ];
}
